<template>
  <div class="text-sm bg-info-muted text-muted-foreground rounded-sm p-4 flex gap-2 info-box relative">
    <InformationCircleIcon class="size-4 flex-none" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
</script>

<style scoped>
.info-box::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 3px;
  width: 0;
  height: 0;
  border-bottom: 6px solid var(--color-info-muted);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
</style>
